import PropTypes from 'prop-types';

import { trans } from '@spotahome/soyuz/client';

import { DSIcon } from '../../../base';
import Tooltip from '../Tooltip/Tooltip';

import styles from './Scoring.module.scss';

const Scoring = ({ score, totalReviews }) => {
  return (
    <Tooltip
      color="tertiary"
      tooltip={trans('scoring-tooltip')}
      textClassName={styles.scoring__tooltip}
      trigger={['click', 'hover']}
      position="left"
    >
      <div className={styles.scoring__content}>
        <DSIcon name="star" />
        <span>
          {score}({totalReviews})
        </span>
      </div>
    </Tooltip>
  );
};

Scoring.propTypes = {
  score: PropTypes.number.isRequired,
  totalReviews: PropTypes.number.isRequired
};

export default Scoring;
